
<div style='width:80%;padding:100px'>
    <h3>Cancellation/Refund Policy:</h3><br />

Cancel anytime, no refund will be processed for any Subscription level. 
If you choose to cancel your membership simply click the 'Cancel Membership' button as part of you group settings, you will sustain your subscription until the next billing period, no more charge will be processed on your account.
<br/>
<br/>
Each subscription level can create events with up to 4 players.

</div>